<script setup lang="ts">
import ConnectionRow from './ConnectionRow.vue'
import type { ConnectionMetadata } from '~/models/connectionMetadata'

// `variant` is retained for API stability but the visual emphasis for failing
// rows now lives on the row itself (red-tinted card). Kept here so the parent
// keeps signalling intent — useful if we ever add section-level treatment.
withDefaults(
  defineProps<{
    utasConnectionsOnly: boolean
    connectionMetaList: ConnectionMetadata[]
    userCanEditConnections?: boolean
    fixOnly?: boolean
    variant?: 'default' | 'needs-attention'
  }>(),
  {
    userCanEditConnections: true,
    fixOnly: false,
    variant: 'default',
  }
)
</script>

<template>
  <div class="connection-list">
    <ConnectionRow
      v-for="meta in connectionMetaList"
      :key="meta.type"
      :connection-meta="meta"
      :editable="userCanEditConnections"
      :utas-connections-only="utasConnectionsOnly"
      :fix-only="fixOnly"
    />
    <slot />
  </div>
</template>

<style scoped lang="scss">
.connection-list {
  container-name: conn-list;
  container-type: inline-size;
  @apply flex flex-col gap-2;
}
</style>
